import authAxios from "../common/authAxios";

class DocumentPageService {
    async saveDocuments(data) {
        return await authAxios.post("/documents/save-document/block/2", data)
    }

    async uploadPhoto(photoFile, type) {
        const formData = new FormData();
        formData.append("documentFile", photoFile);
        return await authAxios.post(`/file/upload-document?type=${type}`, formData, {
            headers: { "Content-Type": "multipart/form-data" }
        })
    }

    async getDocuments(){
        return await authAxios.get('/documents/');
    }
}

export default DocumentPageService;
